'use strict'
/**
 * ai-T编辑器-自定义积木功能模块
 * @author linhui.zhang
 */

import Blockly from '@/assets/blockly/renderers/index.js'
import bus from '@/utils/bus'
import { mapMutations } from 'vuex'
//实训接口
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'

export const CreateBlock = {
  data() {
    return {
      newBlocksType: null, //自建积木类型
      newBlocks: null, //自建积木类工具箱的积木;
      paramArr: [
        // {
        //   paramText: "text or number",
        //   textWidth: 80,
        //   attr: "paramLabel"
        // }
      ],
      renameDefBlockObj: {}, //缓存重命名的自定义积木
    }
  },
  watch: {},
  created() {
    this.newBlocks = this.$store.state.CREATEBLOCK.newBlocks
    //监听-运行区点击确定建积木
    bus.$on('confirmNewBlock', (newBlockPythonCode) => {
      this.confirmGetNewBlock(newBlockPythonCode)
    })
    bus.$on('GetDefUserBlockList', (newBlockPythonCode) => {
      this.GetDefUserBlockList()
    })
  },
  mounted() {},
  beforeDestroy() {
    bus.$off('confirmNewBlock')
    bus.$off('GetDefUserBlockList')
  },
  methods: {
    /**
     * 自定义积木-弹框功能
     * */
    // 创建新积木按钮
    openCreateBlockDialog() {
      //打开创建新积木弹框
      this.popupActive = 'createBlock'
      this.paramArr = []
      bus.$emit('initDefBlockName') //初始化自定义积木的名称
    },
    //确定新建积木--用户匹配代码的积木;
    async confirmCreateNewBlock(newBLockInfo) {
      let blockName = 'DEF_BLOCK_' + newBLockInfo.blockName,
        toolboxXml = document.getElementById('toolBox'),
        parentXmlDom,
        xmlDom,
        blockCodeTxt,
        inputComplete = true,
        oldWorkspaceXml = Blockly.Xml.workspaceToDom(this.workspace)

      this.newBLockInfo = newBLockInfo

      if (!newBLockInfo.blockName) return this.$message.error('请输入积木名称')
      newBLockInfo.paramsList.forEach((item) => {
        if (!item.paramText) {
          inputComplete = false
          return this.$message.error('参数名称未填写完整!')
        }
      })
      if (!inputComplete) return false
      const { newBlocksType } = this
      //获取拼接的积木代码;
      this.getCreateNewCode(newBLockInfo)
      blockCodeTxt = this.$store.state.CREATEBLOCK.newBlockCodeStr

      // 将积木添加到相应类别里面blockCodeTxt:积木脚本，添加到Dom中;
      xmlDom = this.addCustomBlockByJS(
        //生成自定义积木
        Blockly,
        null,
        blockCodeTxt,
        blockName,
        this
      )
      this.popupActive = ''
      //将积木添加到新建积木类别中
      if (xmlDom && newBlocksType.blocksId) {
        parentXmlDom = toolboxXml.querySelector(
          "[id='" + newBlocksType.blocksId + "']"
        )
        if (parentXmlDom) parentXmlDom.appendChild(xmlDom)
        this.workspace.dispose() //处置，防止内存泄漏prevent memory leaks
        await this.blocklyInit(oldWorkspaceXml)
      }
    },

    /**
     * 自定义-点击“确定新建积木”按钮后执行创建自定义积木功能
     * */
    //创建积木步骤3 确定建立一个新功能的积木
    confirmGetNewBlock(newBlockPythonCode) {
      const { newBlockObj, newBlockParamsList } = this.$store.state.CREATEBLOCK //积木的名称和参数变量;
      newBlockPythonCode = newBlockPythonCode.replace(/\r/g, '\n') //去除左侧空格;
      newBlockPythonCode = this.newBlockPythonCodeHandler(
        newBlockPythonCode,
        newBlockParamsList
      ) //处理python 文本;
      const newBlockText_2 = this.$store.state.CREATEBLOCK.newBlockText_2 //blockly脚本的文本
      let newBlockPythonText //blockly的python脚本的文本;
      // 'DEF_BLOCK_' 作为自定义积木的标志；用于工作区解析自定义积木脚本;
      newBlockPythonText = `Blockly.Python["DEF_BLOCK_${newBlockObj.blockName}"]=function(block) {
    ${this.paramValText}
    return '${newBlockPythonCode}';
  };`
      const newBlockScript = newBlockText_2 + newBlockPythonText //拼接字符串
      this.newBlockScript = newBlockScript
      this.createBlockApi(newBlockScript)
    },
    //处理python 文本 包括对应参数的处理;
    newBlockPythonCodeHandler(newBlockPythonCode, newBlockParamsList) {
      const reg_3 = /(.*)\n/g //匹配换行
      let newStr = ''
      let getCodeTextArr = newBlockPythonCode.match(reg_3)
      // newBlockPythonCode = newBlockPythonCode.replace(/^\s*|\s*$/g, "");//去除左侧空格;
      getCodeTextArr.forEach((item) => {
        let item2 = item.replace(/[\r\n]/g, '')
        if (item2) {
          item2 = item2.replace(/^\s{4}/, '') // 去除左侧4个空格;
          // item2 = item2.replace(/^\s*|\s*$/g, ""); //去除左侧4个空格;
          item2 = item2.replace(/"/g, '\\"')
          item2 = item2.replace(/'/g, "\\'")
          item2 = this.insertPythonParam(item2, newBlockParamsList) //判断并插入python参数;
          newStr = newStr + item2 + '\\n' //去除左侧空格;
          // newStr = newStr + item2.replace(/^\s*|\s*$/g, "") + "\\n"; //去除左侧空格;
        }
      })

      return newStr
    },
    //判断并向python脚本插入参数;
    insertPythonParam(item, newBlockParamsList) {
      let paramVal, paramName, paramName_reg, paramName_reg2, paramName_reg3
      // item = item.replace(/\s+/g, ""); //去掉所有的空格，避免匹配偏差;
      newBlockParamsList.forEach((param) => {
        paramName = param.paramText
        //paramName_reg, paramName_reg2, paramName_reg3是为了匹配常见的空白符;
        paramName_reg = new RegExp(param.paramText + '=')
        paramName_reg2 = new RegExp(param.paramText + ' =')
        paramName_reg3 = new RegExp(param.paramText + '  =')

        paramVal = `var ${paramName} =block.getFieldValue('${paramName}');\n`
        if (
          paramName_reg.test(item) ||
          paramName_reg2.test(item) ||
          paramName_reg3.test(item)
        ) {
          item = paramName + '=' + `'+ ${paramName}+'` //拼接变量
          this.paramValText += paramVal //获取变量的脚本
        }
      })
      return item
    },
    /**
     新建自定义积木接口
     @params token
     @data value 自定义积木块
     @
     */
    async createBlockApi(defBlocksContent) {
      let self = this
      const defBlocksName = 'DEF_BLOCK_' + this.newBLockInfo.blockName
      const newBlocksType = this.$store.state.CREATEBLOCK.newBlocksType //新建积木类型;
      const parentId = newBlocksType.blocksId
      const blocksLevel = newBlocksType.blocksLevel + 1
      // const ShowType = 2;//积木类型的显示

      const data = {
        defBlocksName: defBlocksName,
        defBlocksContent: defBlocksContent,
        parentId: parentId,
        blocksLevel: blocksLevel,
      }
      let res = await BLOCK.insertDefBlocks(data)
      if (res && res.isSuccess) {
        // 返回全部自定义积木列表
        this.GetDefUserBlockList()
        this.$message.success('生成积木成功')
        // 获取生成的积木，并解析在工具箱渲染出来;
        setTimeout(function refresh() {
          self.reload()
        }, 500)
      } else {
        this.$message.error('生成积木失败：' + res.ErrorMsg)
      }
    },

    /**
     获取用户的自定义积木列表
     * */
    async GetDefUserBlockList() {
      let data = {
          createBy: this.createBy,
        },
        res
      res = await BLOCK.getDefBlocksByUserId(data)
      if (res && res.isSuccess) {
        const defBlockList = res.data
        this.defBlockList = defBlockList
        defBlockList.forEach((blockItem) => {
          this.addDefBlockTextToTool(blockItem)
        })
        return new Promise(function(resolve, reject) {
          resolve(true)
        })
      }
      return new Promise(function(resolve, reject) {
        resolve(false)
      })
    },
    //添加自定义积木到工具箱
    addDefBlockTextToTool(blockItem) {
      let toolboxXml = document.getElementById('toolBox'),
        oldWorkspaceXml = Blockly.Xml.workspaceToDom(this.workspace),
        parentXmlDom, //积木类型的父节点
        blockName = blockItem.defBlocksName,
        blockCodeTxt = blockItem.defBlocksContent,
        blockFunc,
        blockXml,
        blockXmlDom = null,
        O = this //运行环境
      if (!blockCodeTxt) {
        return null
      }
      blockFunc = new Function(
        'Blockly',
        'deleteDefBlocks',
        'renameDefBlocks',
        blockCodeTxt
      )
      blockFunc.call(O, Blockly, this.deleteDefBlocks, this.renameDefBlocks)
      if (Blockly.Blocks[blockName]) {
        blockXml = O.workspace.newBlock(blockName) //新建的积木
        blockXmlDom = Blockly.Xml.blockToDom(blockXml) //工具箱创建积木
        //对积木进行组合处理
        parentXmlDom = toolboxXml.querySelector(
          `[id='${this.newBlocksType.blocksId}']`
        )
        if (parentXmlDom) {
          parentXmlDom.appendChild(blockXmlDom)
          this.workspace.dispose() //处置，防止内存泄漏prevent memory leaks
        }
        this.blocklyInit(oldWorkspaceXml)
      }

      //对每个积木添加帮助文档跳转路径
      Blockly.Msg[
        blockName
      ] = `/projects/aiTEditor/helpdocument?menu=${blockItem.parentId}#${blockName}`
    },

    /**
     删除自定义积木功能
     * */
    deleteDefBlocks(blockName) {
      let self = this,
        typeBlocks = this.workspace.getBlocksByType(blockName),
        typeBlocksLen = typeBlocks.length,
        msgConfirm = `要删除对改自定义积木的 ${typeBlocksLen} 个引用吗？`
      if (typeBlocksLen) {
        this.$confirm(msgConfirm).then((action) => {
          if (action === 'confirm') {
            this.deleteDefBlocksByBlocksId(blockName).then((/*result*/) => {
              // 删除 workspace 中的积木
              console.log('typeBlocks', typeBlocks)
              typeBlocks.forEach((block) => {
                block.dispose(false, true)
              })
              self.$parent.$parent.saveFile()
              setTimeout(() => {
                self.reload()
              }, 200)
            })
          } else {
            return
          }
        })
      } else {
        this.deleteDefBlocksByBlocksId(blockName).then((/*result*/) => {
          // 删除 workspace 中的积木
          typeBlocks.forEach((block) => {
            block.dispose(false, true)
          })
          self.$parent.$parent.saveFile(3)
          setTimeout(() => {
            self.reload()
          }, 200)
        })
      }
    },
    deleteDefBlocksByBlocksId(blockName) {
      let self = this,
        { defBlockList } = this,
        data = {}

      defBlockList.forEach((item) => {
        if (item.defBlocksName == blockName) {
          data.defBlocksId = item.defBlocksId
        }
      })
      return new Promise((resolve, reject) => {
        BLOCK.deleteDefBlocks(data).then((res) => {
          if (res && res.returnCode == 200) {
            // this.GetDefUserBlockList()
            // 获取生成的积木，并解析在工具箱渲染出来;
            resolve(res)
          }
        })
      })
    },
    /**
     重命名自定义积木功能
     * */
    renameDefBlocks(blockName) {
      this.renamePicObj = {}
      this.renameCamObj = {}
      this.renameAudioObj = {}
      this.renameTextObj = {}
      ;(this.renameDefBlockObj = { mediaFileName: blockName }),
        (this.popupActive = 'rename')
    },
    //确定自定义积木的重命名
    confirmReanmeDefBlock() {
      this.popupActive = ''
      let reg_name = /[`~!@#$^&*()=|{}':;',\\[\]<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g
      let renameVal = 'DEF_BLOCK' + this.renameVal.replace(reg_name, '')
      let renameObj = this.renameDefBlockObj
      console.log('renameVal', renameVal)
      console.log('renameObj', renameObj)

      this.renameDefBlockObj = {}
    },

    ...mapMutations(['getCreateNewCode']),
  },
}
